import { Modal } from "react-bootstrap";
import DataTable from "../../../../common/DataTable";
import {
  CaseStageHistory,
  fetchStageStatusLogDetails,
} from "../../../../services/CaseInformationApi";
import { useEffect, useState } from "react";
import { dateTimeFormatted } from "../../../../utils/dateUtils";
import { STAGE_STATUS_LOG_HEADERS } from "../../../Case_Management/Case_Information/actions/Constant";
import { getInvoiceReportLogs } from "../../../../services/InvoiceReportsApi";
import { INVOICE_REPORTS_LOGS_HEADER } from "../actions/constant";

interface StageStatusLogsProps {
  show: boolean;
  handleClose: () => void;
  caseInfoId: any;
}

const InvoiceReportsLogs: React.FC<StageStatusLogsProps> = ({
  show,
  handleClose,
  caseInfoId,
}) => {
  const [logRows, setLogRows] = useState<CaseStageHistory[]>([]);

  const fetchLogsData = async () => {
    try {
      const listData = await getInvoiceReportLogs(caseInfoId);
      const formattedData = (listData || [])?.map((item: any) => ({
        ...item,
        oldAmount: item.oldAmount == null ? "-" : item.oldAmount,
        updatedOn: item.updatedOn ? dateTimeFormatted(item.updatedOn) : "-",
      }));
      setLogRows(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (show && caseInfoId) {
      fetchLogsData();
    }
  }, [show, caseInfoId]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="recordList"
    >
      <Modal.Header closeButton className="d-flex">
        <Modal.Title className="fw-bold text-left modelheading offcanvas-title">
          Audit Log
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DataTable headers={INVOICE_REPORTS_LOGS_HEADER} rows={logRows} />
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceReportsLogs;
